import styled, { keyframes } from "styled-components";
import { FiChevronRight } from "react-icons/fi";
import { useHistory } from "react-router-dom";

const sections = [
  {
    title: "Dénomination et siège social",
    content: `La Petite Charrue
13 rue Principale
90150 Vauthiermont

Siret : 45295260900017
RCS : Belfort B 452 952 609`,
  },
  {
    title: "Création & Conception du site",
    content: "Heidet Antoine",
  },
  {
    title: "Récépissé de déclaration",
    content: `Lorsqu'un site web diffuse ou collecte des données à caractère personnel, il doit être déclaré à la CNIL.
Toutefois, les sites web mis en œuvre par des particuliers dans le cadre d'une activité exclusivement personnelle sont dispensés de déclaration.
À l'inverse, la diffusion et la collecte de données à caractère personnel à partir d'un site web dans le cadre d'activités professionnelles, politiques ou associatives restent soumises à l'accomplissement des formalités prévues par la loi.`,
  },
  {
    title: "Rectification et suppression des données",
    content: `En application de la Loi n° 78-17 du 6 janvier 1978 relative à l'Informatique, aux Fichiers et aux Libertés, vous disposez des droits d'opposition (art. 26), d'accès (art. 34 à 38) et de rectification (art. 36) des données vous concernant.
Ainsi, vous pouvez exiger que soient rectifiées, complétées, mises à jour ou effacées les informations vous concernant qui sont inexactes, incomplètes, équivoques, périmées ou dont la collecte ou l'utilisation est interdite.`,
  },
  {
    title: "Hébergement — OVH",
    content: `OVH SAS
RCS Lille Métropole 424 761 419 00045 — Code APE 2620Z
N° TVA : FR 22 424 761 419
Siège social : 2 rue Kellermann — 59100 Roubaix — France

En application de la loi du 11 mars 1957 (art. 41) et du code de la propriété intellectuelle du 1er juillet 1992, toute reproduction partielle ou totale à usage collectif est strictement interdite sans autorisation de l'éditeur du présent site.
Les logos, visuels et marques présents sur ce site sont la propriété de leur détenteur respectif. L'éditeur ainsi que la société La Petite Charrue déclinent toute responsabilité pour les informations présentées sur d'autres sites liés par hyperliens. L'internaute reconnaît que l'utilisation du présent site est régie par le droit français.`,
  },
];

export default function Mentions() {
  const navigate = useHistory();

  return (
    <Page>
      <PageHeader>
        <Breadcrumb>
          <BreadLink onClick={() => navigate.push("/")}>Accueil</BreadLink>
          <FiChevronRight />
          <span>Mentions légales</span>
        </Breadcrumb>
        <PageTitle>Mentions Légales</PageTitle>
        <GoldBar />
      </PageHeader>

      <Content>
        {sections.map(({ title, content }, i) => (
          <MentionCard key={i}>
            <CardIndex>{String(i + 1).padStart(2, "0")}</CardIndex>
            <CardBody>
              <CardTitle>{title}</CardTitle>
              <CardText>{content}</CardText>
            </CardBody>
          </MentionCard>
        ))}
      </Content>

      <BackRow>
        <BackBtn onClick={() => navigate.push("/")}>
          ← Retour à l'accueil
        </BackBtn>
      </BackRow>
    </Page>
  );
}

/* ─── Keyframes ─── */
const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

/* ─── Styled Components ─── */

const Page = styled.div`
  min-height: 100vh;
  background: var(--bg-base);
  padding-top: 72px;
`;

const PageHeader = styled.header`
  padding: 4rem 5vw 3rem;
  text-align: center;
  animation: ${fadeUp} 0.7s ease both;
`;

const Breadcrumb = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.8rem;
  color: var(--cream-muted);
  letter-spacing: 0.06em;
  margin-bottom: 1.5rem;

  svg { font-size: 0.75rem; }
`;

const BreadLink = styled.span`
  cursor: pointer;
  transition: color 0.2s;
  &:hover { color: var(--primary); }
`;

const PageTitle = styled.h1`
  font-family: var(--font-heading);
  font-size: clamp(2rem, 5vw, 3.2rem);
  color: var(--cream);
  font-weight: 500;
  letter-spacing: 0.04em;
`;

const GoldBar = styled.div`
  width: 60px;
  height: 2px;
  background: linear-gradient(to right, transparent, var(--primary), transparent);
  margin: 1rem auto 0;
`;

const Content = styled.main`
  max-width: 820px;
  margin: 0 auto;
  padding: 0 5vw 3rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const MentionCard = styled.article`
  display: flex;
  gap: 1.5rem;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 1.75rem;
  animation: ${fadeUp} 0.5s ease both;

  &:nth-child(1) { animation-delay: 0.05s; }
  &:nth-child(2) { animation-delay: 0.1s; }
  &:nth-child(3) { animation-delay: 0.15s; }
  &:nth-child(4) { animation-delay: 0.2s; }
  &:nth-child(5) { animation-delay: 0.25s; }

  &:hover {
    border-color: rgba(200, 151, 62, 0.28);
  }

  @media (max-width: 560px) {
    flex-direction: column;
    gap: 0.75rem;
    padding: 1.25rem;
  }
`;

const CardIndex = styled.span`
  font-family: var(--font-heading);
  font-size: 2rem;
  color: var(--border);
  font-weight: 700;
  line-height: 1;
  flex-shrink: 0;
  min-width: 2.5rem;
  padding-top: 0.15rem;

  @media (max-width: 560px) { font-size: 1.4rem; }
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

const CardTitle = styled.h3`
  font-family: var(--font-heading);
  font-size: 1.05rem;
  color: var(--primary);
  font-weight: 500;
`;

const CardText = styled.p`
  font-size: 0.88rem;
  color: var(--cream-dim);
  line-height: 1.85;
  white-space: pre-line;
  letter-spacing: 0.02em;
`;

const BackRow = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 5vw 5rem;
`;

const BackBtn = styled.button`
  padding: 0.75rem 2rem;
  background: transparent;
  border: 1px solid var(--border);
  color: var(--cream-dim);
  font-family: var(--font-body);
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: var(--transition);

  &:hover {
    border-color: var(--primary);
    color: var(--primary);
    background: var(--primary-glow);
  }
`;
